import React from 'react'

const AdminHeader = () => {
  return (
    <>
    <header className="bg-white/10 backdrop-blur-xl border-b border-white/20 text-white px-6 py-4 flex justify-between items-center">
      <h1 className="text-lg font-semibold">Admin Dashboard</h1>
    </header>
    </>
  )
}

export default AdminHeader
